import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { SCREENS } from '@/utils/constants';

export function FaqScreen() {
  const { t } = useLocalization();

  return (
    <BotMessage text={t('faq.message')} />
  );
}

export function FaqUnsureScreen() {
  const { t } = useLocalization();
  const { goTo, goToMenu } = useWidget();

  return (
    <BotMessage text={t('faq.unsureMessage')}>
      <ScreenOptions>
        <OptionButton variant="primary" onClick={() => goTo(SCREENS.MANAGER)}>
          {t('faq.yesConnect')}
        </OptionButton>
        <OptionButton onClick={goToMenu}>
          {t('faq.no')}
        </OptionButton>
      </ScreenOptions>
    </BotMessage>
  );
}
